<template>
  <InvoiceParameterDefaultModal
    title="Cancelar configuração?"
    width="500"
    showOctagon
    :show="show"
    @close="confirm(false)">
    <template slot="icon">
    </template>
    <template slot="body">
      <div>
        <TextBase>
          Você tem certeza que deseja cancelar essa configuração?
        </TextBase>
        <TextBase>
          Todas as alterações não salvas serão perdidas.
        </TextBase>
      </div>
    </template>
    <template slot="actions">
      <div
        class="d-flex justify-end gap-h-20 fill-width">
        <v-btn
          class="action-button-modal"
          color="primary"
          outlined
          @click="confirm(false)">
          Continuar editando
        </v-btn>
        <v-btn
          class="action-button-modal"
          color="error"
          @click="confirm(true)">
          Sim, cancelar
        </v-btn>
      </div>
    </template>
  </InvoiceParameterDefaultModal>
</template>
<script>
import InvoiceParameterDefaultModal from './InvoiceParameterDefaultModal.vue';
import InvoiceParameterText from '../components/InvoiceParameterText.vue';
import { mapMutations } from 'vuex';

export default {
  name: "CancelConfirmModal",
  components: {
    InvoiceParameterDefaultModal,
    TextBase: InvoiceParameterText,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true,
    }
  },
  methods: {
    ...mapMutations({
      setShowCancelConfirmModal: 'invoice-parameter/setShowCancelConfirmModal',
    }),
    confirm(confirmation) {
      this.$emit('confirm', confirmation);
      this.setShowCancelConfirmModal(false);
    }
  }
}
</script>
<style lang="scss">
@import "@/shared/styles/invoiceParameters/default.scss";
</style>